import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import EmailMessageThreadForm from '../../../components/forms/EmailMessageThreadForm';
import { useEmailMessageThreadApi } from '../../../hooks/useEmailMessageThreadApi';
import { useNavigate, useParams } from 'react-router-dom';
import { EmailMessageThreadDTO } from '../../../services/apiClient';
import { useEmailMessageApi } from '../../../hooks/useEmailMessageApi';

const EmailMessageThreadEdit: React.FC = () => {
  const { getById } = useEmailMessageThreadApi();
  const { createReply } = useEmailMessageApi();
  const [entityData, setEntityData] = useState<EmailMessageThreadDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Email Message Threads', href: '/admin/replies' },
    { label: 'Reply', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching EmailMessageThread data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await createReply(data);
      navigate(-1);
    } catch (error) {
      console.error('Error updating EmailMessageThread:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/replies"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Manage.EmailMessageThread.Edit'
    >
        {entityData ? (
          <EmailMessageThreadForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate(-1)}
            isLoading={isSubmitting}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default EmailMessageThreadEdit;